module.exports = __webpack_public_path__ + "img/circle-unchecked.a1504808.svg";